export default "__VITE_ASSET__990e2334__"